import React from 'react'
import Image from 'next/image'
import { createBucketClient } from '@cosmicjs/sdk'

import PageLayout from '@/components/PageLayout'

import s from './Agreement.module.scss'

const HealthGuaranteeAgreement = ({ content }) => {
  const lastUpdated = new Date(content[0]?.modified_at).toLocaleDateString(
    'en-US',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
  )

  const heroComponent = (
    <>
      <div className={s.imageDesktop}>
        <Image
          src="/health-guarantee/agreement-hero-desktop.png"
          style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
          width={1074}
          height={250}
          quality={100}
          alt="Dog doctor"
          priority
        />
      </div>
      <div className={s.imageMobile}>
        <Image
          src="/health-guarantee/agreement-hero-mobile.png"
          style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
          width={400}
          height={200}
          quality={100}
          alt="Dog doctor"
          priority
        />
      </div>
    </>
  )

  return (
    <PageLayout title="Health Guarantee Agreement" hero={heroComponent}>
      <div className={s.agreement}>
        <div className={s.agreement_container}>
          <h1 className={s.agreement_container_title}>
            Mawoo Pets Health Guarantee Agreement
          </h1>
          <h2 className={s.agreement_container_sub}>
            Last Updated: {lastUpdated}
          </h2>

          <div className={s.agreement_index}>
            <h4 className={s.agreement_container_sub}>Table of Contents</h4>
            <div className={s.agreement_list}>
              {content[0]?.metadata?.contents.map((content, index) => (
                <a
                  key={index}
                  href={`#${content.content_title}`}
                  className={s.agreement_list_link}
                >
                  {content.content_title}
                </a>
              ))}
            </div>

            <div>
              {content[0]?.metadata?.contents.map((content, index) => (
                <div key={index} className={s.agreement_content}>
                  <h3
                    id={content.content_title}
                    className={s.agreement_content_title}
                  >
                    {content.content_title}
                  </h3>
                  <div
                    className={s.agreement_content_item}
                    dangerouslySetInnerHTML={{
                      __html: content.content_item,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default HealthGuaranteeAgreement

export async function getStaticProps() {
  const cosmic = createBucketClient({
    bucketSlug: process.env.NEXT_PUBLIC_COSMIC_BUCKET_SLUG || '',
    readKey: process.env.NEXT_PUBLIC_COSMIC_BUCKET_READ_KEY || '',
  })

  let content = []
  try {
    const data = await cosmic.objects.find({
      type: 'health-guarantee-agreement',
    })

    if (data.objects) content = data.objects
  } catch (error) {
    console.error('HEALTH GUARANTEE AGREEMENT // Error:', error)
  }

  return {
    props: {
      content,
    },
  }
}
